"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { getSafeCallbackUrl } from "@/lib/auth/safe-callback-url";

const RESET_PATH_FRAGMENT = "/reset-password";

export default function InitialPasswordGate({ children }) {
  const { data: session, status } = useSession();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (status !== "authenticated") return;
    if (!session?.user?.initialSignIn) return;
    if (pathname?.includes(RESET_PATH_FRAGMENT)) return;

    const currentPath =
      `${window.location.pathname}${window.location.search}${window.location.hash}` ||
      pathname ||
      "/";
    const params = new URLSearchParams({
      forceInitial: "true",
      callbackUrl: getSafeCallbackUrl(currentPath),
    });

    router.replace(`/reset-password?${params.toString()}`);
  }, [pathname, router, session?.user?.initialSignIn, status]);

  if (status === "authenticated" && session?.user?.initialSignIn) {
    if (!pathname?.includes(RESET_PATH_FRAGMENT)) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50 px-6">
          <div className="max-w-md text-center">
            <p className="text-sm font-medium text-gray-900">
              Redirecting to set your password...
            </p>
            <p className="mt-2 text-xs text-gray-600">
              You must set a new password before using the app.
            </p>
          </div>
        </div>
      );
    }
  }

  return children;
}
